// Package Imports
import { notification } from 'antd';
import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
// Project Imports
import ConfigStyle from 'core/constants/ConfigStyle';

export type NotificationType = 'success' | 'info' | 'warning' | 'error';

const openNotificationWithIcon = (
  type: string | NotificationType,
  message: any,
  description?: any,
  duration: number = 4.5 // Default duration of 4.5 seconds (between 2-5)
) => {
  let desc: React.ReactNode = description;
  if (description) {
    const parts = description
      .split('|')
      .map((part, index) => <p key={index}>{part}</p>);
    desc = parts;
  }

  let borderColor;
  let backgroundColor;
  switch (type) {
    case 'success':
      borderColor = ConfigStyle.colors['success-500'];
      backgroundColor = ConfigStyle.colors['success-50'];
      break;
    case 'warning':
      borderColor = '#faad14';
      backgroundColor = '#fff7cc';
      break;
    case 'error':
      borderColor = ConfigStyle.colors['danger-500'];
      backgroundColor = ConfigStyle.colors['danger-50'];
      break;
    default:
      borderColor = ConfigStyle.colors['info-500'];
      backgroundColor = ConfigStyle.colors['info-50'];
  }
  const notificationBorderStyle = {
    border: `1px solid ${borderColor}`,
    backgroundColor,
  };

  notification[type]({
    message,
    description: desc,
    style: {
      ...notificationBorderStyle,
      borderRadius: '6px',
    },
    duration,
    closeIcon: <CloseOutlined />,
  });
};

export default openNotificationWithIcon;
